const NEWSLETTER_POPUP_COOKIE_NAME = 'newsletter-popup-status';
const NEWSLETTER_POPUP_MAX_AGE_DISMISS = 60 * 60 * 24 * 7;
const NEWSLETTER_POPUP_MAX_AGE_SUCCESSFUL = 60 * 60 * 24 * 365;

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    this.dialog = this.querySelector('dialog');
    this.success = this.querySelector('.success');
    this.errors = this.querySelector('.errors');

    this.cookie = getCookie(NEWSLETTER_POPUP_COOKIE_NAME);

    this.delay = parseInt(this.attributes.delay?.value || 5) * 1_000;
    this.openImmediately = this.success || this.errors;

    this.dialog.addEventListener('close', this.onClose.bind(this));

    if (this.cookie || Shopify.designMode) return;
    if (this.success) this.setCookie();

    setTimeout(this.open.bind(this), this.openImmediately ? 0 : this.delay);
  }

  onClose(ev) {
    this.dismiss();
  }

  open() {
    this.dialog.showModal();
  }

  dismiss() {
    this.setCookie();
  }

  setCookie(success = this.success) {
    let status = success ? 'successful' : 'dismissed';
    let max_age = success ? NEWSLETTER_POPUP_MAX_AGE_SUCCESSFUL : NEWSLETTER_POPUP_MAX_AGE_DISMISS;
    document.cookie = `${NEWSLETTER_POPUP_COOKIE_NAME}=${status}; max-age=${max_age}`;
  }

  deleteCookie() {
    document.cookie = `${NEWSLETTER_POPUP_COOKIE_NAME}=; max-age=0`;
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
